(function () {
  if (window.__stmnHybridArticleI18n) return;
  window.__stmnHybridArticleI18n = true;

  var EN = "en";
  var FORCE_KEY = "stmn_hybrid_force_lang";

  function queryLang() {
    try {
      return new URLSearchParams(window.location.search).get("stmn_lang");
    } catch (e) {
      return null;
    }
  }

  function persistForcedLang() {
    if (queryLang() === EN) {
      try {
        sessionStorage.setItem(FORCE_KEY, EN);
      } catch (e) {}
    }
  }

  function forcedLang() {
    persistForcedLang();
    try {
      return sessionStorage.getItem(FORCE_KEY);
    } catch (e) {
      return null;
    }
  }

  function clearForcedLang() {
    try {
      sessionStorage.removeItem(FORCE_KEY);
    } catch (e) {}
  }

  function cleanLangQuery() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has("stmn_lang")) return;
      url.searchParams.delete("stmn_lang");
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  function currentLang() {
    if (forcedLang() === EN) return EN;
    try {
      if (window.Weglot && typeof Weglot.getCurrentLang === "function") {
        return Weglot.getCurrentLang();
      }
    } catch (e) {}
    if (/^\/en(?:\/|$)/i.test(window.location.pathname)) return EN;
    return "it";
  }

  function syncWeglot(lang) {
    if (lang !== EN) return;
    try {
      if (window.Weglot && typeof Weglot.switchTo === "function") {
        Weglot.switchTo(EN);
      }
    } catch (e) {}
  }

  function setTitle(el, text) {
    if (!el || !text) return;
    var split = el.querySelector("split-words");
    if (split) split.textContent = text;
    else el.textContent = text;
  }

  function applyArticle(root, lang) {
    if (!root) return;
    if (lang !== EN) {
      root.dataset.stmnHybridApplied = "";
      return;
    }

    var titleTpl = document.getElementById("stmn-article-i18n-en-title");
    var bodyTpl = document.getElementById("stmn-article-i18n-en-body");
    var titleEl = root.querySelector("[data-stmn-article-title]");
    var bodyEl = root.querySelector("[data-stmn-article-body]");

    if (titleEl && titleTpl) {
      var titleText = titleTpl.content ? titleTpl.content.textContent.trim() : titleTpl.innerHTML.trim();
      if (titleText) {
        setTitle(titleEl, titleText);
        var suffix = document.title.indexOf("–") > -1 ? document.title.slice(document.title.indexOf("–")) : "";
        document.title = titleText + (suffix ? " " + suffix : "");
      }
    }

    if (bodyEl && bodyTpl) {
      bodyEl.innerHTML = bodyTpl.innerHTML;
    }

    root.dataset.stmnHybridApplied = "1";
  }

  function applyCards(lang) {
    document.querySelectorAll("[data-stmn-hybrid-card]").forEach(function (card) {
      if (lang !== EN) {
        card.dataset.stmnCardApplied = "";
        return;
      }

      var title = card.getAttribute("data-stmn-title-en") || "";
      var excerpt = card.getAttribute("data-stmn-excerpt-en") || "";

      if (title) {
        card.querySelectorAll(".bl__card-title a, .bc__card-title, .article-card__title").forEach(function (el) {
          el.textContent = title;
        });
      }

      if (excerpt) {
        card.querySelectorAll(".bl__card-excerpt, .bc__card-excerpt, .article-card__bottom").forEach(function (el) {
          el.textContent = excerpt;
        });
      }

      card.dataset.stmnCardApplied = "1";
    });
  }

  function applyAll() {
    var lang = currentLang();
    syncWeglot(lang);
    document.querySelectorAll("[data-stmn-hybrid-article]").forEach(function (root) {
      applyArticle(root, lang);
    });
    applyCards(lang);
    if (lang === EN && queryLang() === EN) cleanLangQuery();
  }

  function bindWeglot() {
    if (!window.Weglot || typeof Weglot.on !== "function") return;
    Weglot.on("initialized", applyAll);
    Weglot.on("languageChanged", function (lang) {
      if (lang === "it") clearForcedLang();
      applyAll();
    });
  }

  function bind() {
    applyAll();
    bindWeglot();
    setTimeout(applyAll, 100);
    setTimeout(applyAll, 500);
    setTimeout(applyAll, 1500);
    setTimeout(applyAll, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();
